import axiosInstance from "./instance";

const instance = axiosInstance();

export const applyUniversity = async (data) => {
    try {
        const response = await instance.post(`university-applications/apply`, data);
        return response;
    } catch (error) {
        return error;
    }
}

export const applyUniversityTakeIntake = async (data) => {
    try {
        const response = await instance.put(`university-applications/${data.id}`, data);
        return response;
    } catch (error) {
        return error;
    }
}

export const getTeamBasedOnUserId = async (userId) => {
    try {
        const response = await instance.get(`application-team/userId/${userId}`);
        return response;
    } catch (error) {
        return error;
    }
}

export const getAllApplicationTeams = async () => {
    try {
        const response = await instance.get(`application-team?page=0&size=20`);
        return response;
    } catch (error) {
        return error;
    }
}
export const getAllApplicationTeamsByTeamId = async (teamId) => {
    try {
        const response = await instance.get(`application-team/${teamId}`);
        return response;
    } catch (error) {
        return error;
    }
}


export const getTeamApplicationsWithId = async (teamId, page, size) => {
    try {
        const response = await instance.get(`university-applications/team/${teamId}?page=${page}&size=${size}`);
        return response;
    } catch (error) {
        return error;
    }
}

export const getApplicationsWithId = async (applicationId) => {
    try {
        const response = await instance.get(`university-applications/${applicationId}`);
        return response;
    } catch (error) {
        return error;
    }
}


export const getAllApplications = async (page, size) => {
    try {
        const response = await instance.get(`university-applications?page=${page}&size=${size}`);
        return response;
    } catch (error) {
        return error;
    }
}

export const getAllUserApplications = async (userId,page,size) => {
    try {
        const response = await instance.get(`university-applications/user/${userId}?page=${page}&size=${size}`);
        return response;
    } catch (error) {
        return error;
    }
}

export const getAllUserApplicationsBasedOnStatus = async (userId, status,page,size) => {
    try {
        const response = await instance.get(`/university-applications/${userId}/status-filter/${status}?page=${page}&size=${size}`);
        return response;
    } catch (error) {
        return error;
    }
}
export const getAllApplicationsBasedOnStatus = async (status,page,size) => {
    try {
        const response = await instance.get(`/university-applications/status-filter/${status}?page=${page}&size=${size}`);
        return response;
    } catch (error) {
        return error;
    }
}

export const getmasterDataEntity = async (masterDataEntityId) => {
    try {
        const response = await instance.get(`master-data/{id}?id=${masterDataEntityId}`);
        return response;
    } catch (error) {
        return error;
    }
}

export const updateApplication = async (applicationId, data) => {
    try {
        const response = await instance.put(`university-applications/${applicationId}`, data);
        return response;
    } catch (error) {
        return error;
    }
}

export const AssignApplicationToTeam = async (applicationId, data) => {
    try {
        const response = await instance.put(`university-applications/${applicationId}`, data);
        return response;
    } catch (error) {
        return error;
    }
}

export const deleteApplication = async (applicationId, data) => {
    try {
        const response = await instance.delete(`university-applications/${applicationId}`, data);
        return response;
    } catch (error) {
        return error;
    }
}
export const deleteWishlist = async (wishlistId, data) => {
    try {
        const response = await instance.delete(`user-shortlist/${wishlistId}`, data);
        return response;
    } catch (error) {
        return error;
    }
}

export const searchOnApplications = async (serchData) => {
    console.log("Search for application --->",serchData);
    try {
        const response = await instance.post(`university-applications/search`, serchData);
        return response.data;
    } catch (error) {
        return error;
    }
}

export const userWishListPost = async (serchData) => {
    try {
        const response = await instance.post(`/user-shortlist`, serchData);
        return response.data;
    } catch (error) {
        return error;
    }
}
export const userWishListDelete = async (id) => {
    try {
        const response = await instance.delete(`/user-shortlist/${id}`);
        return response.data;
    } catch (error) {
        return error;
    }
}
export const getAllWishlistUniversities = async (userId,page,size) => {
    try {
        const response = await instance.get(`/user-shortlist/get-all/${userId}?page=${page}&size=${size}`);
        return response;
    } catch (error) {
        return error;
    }
}
export const getAllStepperApplications = async (userId, applicationId) => {
    try {
        const response = await instance.get(`reports/${userId}/university-application/status/${applicationId}`);
        return response;
    } catch (error) {
        return error;
    }
}